import { SINGLE } from "../../../constants/numbers.consts.js";
/**
 * Function to create the FeatureDiscovery steps.
 *
 * @param baseSteps - The default steps (e.g., FeatureDiscoveryDefaultSteps or FeatureDiscoveryMobileSteps)
 * @param overrides - An array of objects specifying which steps to override
 * @param inserts - An array of objects specifying where to insert new steps
 * @returns A new array of steps with applied overrides and insertions
 */
export const createStepsUtil = (baseSteps, { overrides = [], inserts = [], skipIds = [] } = {}) => {
    const filteredSteps = baseSteps.filter(({ id }) => !skipIds.includes(id));
    // Apply overrides
    const overriddenSteps = filteredSteps.map((step) => {
        const override = overrides.find((o) => o.id === step.id);
        return override ? { ...step, ...override } : step;
    });
    // Insert new steps
    const finalSteps = inserts.reduce((acc, { before, after, newStep }) => {
        if (!!before?.trim() && !!after?.trim()) {
            console.warn(`You can only use either before or after to insert a step`);
            return acc;
        }
        if (before) {
            const beforeIndex = acc.findIndex(({ id }) => id === before);
            switch (beforeIndex) {
                case -1:
                    return acc;
                case 0:
                    return [newStep, ...acc];
                default:
                    return [...acc.slice(0, beforeIndex), newStep, ...acc.slice(beforeIndex)];
            }
        }
        else if (after) {
            const afterIndex = acc.findIndex(({ id }) => id === after);
            if (afterIndex === acc.length - SINGLE)
                return [...acc, newStep];
            if (afterIndex === 0)
                return [...acc.slice(0, 0), newStep, ...acc.slice(0)];
            const insertAtIndex = afterIndex + SINGLE;
            return [...acc.slice(0, insertAtIndex), newStep, ...acc.slice(insertAtIndex)];
        }
        return acc;
    }, overriddenSteps);
    return finalSteps;
};
export default createStepsUtil;
